import ICONS from "../../../../../assets/Icons";
import globalText from "../../../../../utils/globalText";
import AssignLabels from "../../../../_utils/AccountCreationComponents/AssignLabels";
import CommonLayout from "../../../../_utils/CommonLayout";
import AdditionalDetailsPreviewMapper from "../../../../_utils/TransactionCommonComponents/AdditionalDetailsPreviewMapper";
import Amount from "../../../../_utils/TransactionCommonComponents/Amount";
import CategorySelector from "../../../../_utils/TransactionCommonComponents/CategorySelector";
import CommonDestinationAccount from "../../../../_utils/TransactionCommonComponents/CommonDestinationAccount";
import ConfidentialCard from "../../../../_utils/TransactionCommonComponents/ConfidentialCard";
import PaymentMethodSelector from "../../../../_utils/TransactionCommonComponents/PaymentMethodSelector";
import CommonSourceAccount from "../../../../_utils/TransactionCommonComponents/CommonSourceAccount";

const BeneficiaryTransactionStepConfirm = ({
  txnPayLoad,
  setTxnPayLoad,
  isConfidential,
  previewImages,
  uploadedFiles = {},
  allLabels,
}) => {
  return (
    <>
      <div className="w-width-full Qlg:px-padding-base px-padding-md Qsmd:py-padding-md py-padding-md max-w-tab-width-normal mx-auto">
        <CommonLayout>
          <CommonSourceAccount
            type="source"
            txnPayLoad={txnPayLoad}
            setTxnPayLoad={setTxnPayLoad}
            page="confirm"
          />

          <CommonDestinationAccount
            transactionPayload={txnPayLoad}
            setTransactionPayload={setTxnPayLoad}
            isReadOnly
            showsBalance={false}
          />
          <div className="flex flex-col w-full gap-y-gap-md">
            <Amount isPreview={true} txnPayLoad={txnPayLoad} />
            <PaymentMethodSelector
              previewMode={true}
              showUnassignLink={false}
              selectedMethod={txnPayLoad?.settleType}
            />
          </div>

          <ConfidentialCard
            icon={ICONS?.CONFIDENTIAL_TRANSACTION}
            title={globalText?.CREATE_AS_CONFIDENTIAL}
            note={globalText?.CONFIDENTIAL_TRANSACTION_NOTE}
            toggleState={isConfidential}
            isPreview={true}
          />

          <CategorySelector
            previewMode={true}
            selectedCategory={txnPayLoad?.selectedCategory}
            category={txnPayLoad?.mergeCategory || []}
            IFSC={txnPayLoad?.bankAccountIFSC}
            accountNumber={txnPayLoad?.bankAccountNo}
            beneAccountId={txnPayLoad?.beneAccountId}
            unassignCategories={[]}
            unassignlength={[]}
          />

          <div>
            <AdditionalDetailsPreviewMapper
              mappingData={txnPayLoad?.mergeCategory}
              previewImages={previewImages}
              uploadedFiles={uploadedFiles}
            />
          </div>

          <AssignLabels
            labels={allLabels}
            isOptional={true}
            previewMode={true}
          />
        </CommonLayout>
      </div>
    </>
  );
};

export default BeneficiaryTransactionStepConfirm;
